import { IconSvg, IconSvgProps } from "./icon"

export default function Bug(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M12 19.071A5.786 5.786 0 1 0 12 7.5a5.786 5.786 0 0 0 0 11.571ZM6.214 13.286H3.643M3.643 17.786a4.448 4.448 0 0 0 3.381-1.543" />
      <path d="M7.024 10.329a4.448 4.448 0 0 0-3.381-1.543M17.786 13.286h2.571M20.357 17.786a4.448 4.448 0 0 1-3.381-1.543M16.976 10.329a4.448 4.448 0 0 1 3.381-1.543M13.594 7.719a3.214 3.214 0 0 0 1.62-2.79M8.786 4.929a3.214 3.214 0 0 0 1.62 2.79M6.356 12h11.288" />
    </IconSvg>
  )
}
